import { Link } from 'react-router-dom';

function NavLinks() {
    return (
        <nav className="hidden md:flex flex-wrap justify-center gap-x-4 gap-y-2 mt-2 mb-4 text-sm text-slate-300 z-10" aria-label="Navegação principal">
            <Link to="/" className="hover:underline hover:text-slate-100">🏠 Início</Link>
            <Link to="/create" className="hover:underline hover:text-slate-100">➕ Criar Sala</Link>
            <Link to="/join" className="hover:underline hover:text-slate-100">🔑 Entrar em Sala</Link>
            <Link to="/recursos" className="hover:underline hover:text-slate-100">📑 Recursos</Link>
            <Link to="/guia" className="hover:underline hover:text-slate-100">📚 Guia</Link>
            <Link to="/sobre" className="hover:underline hover:text-slate-100">📄 Sobre</Link>
            <Link to="/faq" className="hover:underline hover:text-slate-100">❓ FAQ</Link>
            <Link to="/privacidade" className="hover:underline hover:text-slate-100">😶 Política de Privacidade</Link>
        </nav>
    );
}

export default NavLinks;
